
import { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { RootState } from '../../../../../core/reducers'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { connect } from 'react-redux'
import {
    actionGetReportDetail,
    actionGetReportDetailByStatus,
    actionSaveReportRemark,
} from '../../../../../core/actions/silizhu/report'
import icon_reportError from './images/icon_reportError.png'
import icon_reportProcessing from './images/icon_reportProcessing.gif'
import { withTranslation, WithTranslationProps } from 'react-i18next'
import { returnReportErrorText } from './reportError'
import "./index.css"
import TextArea from 'antd/lib/input/TextArea'
import { Button } from 'antd'

import CustomerInfo from './scan/customerInfoTable'
import TypeAndSize from "./scan/typeAndSize"
import LengthAndWidth from "./scan/lengthAndWidth"
import FootPartition from './standing/footPartition'
import FeetData from './standing/feetData'
import FeetSynthesis from './standing/feetSynthesis'
import ArchAnaly from './standing/archAnaly'
import StableAnaly from './standing/stableAnaly'


interface PropsData {
    inExport: boolean
}

interface StateProps {
    reportDetail: any
}

interface DispatchProps {
    getReportDetail(data): void
    getReportDetailByStatus(data): void
    saveReportRemark(data): void,
}

interface RouteProps {
    id: string
}

type PropsType = RouteComponentProps<RouteProps> & StateProps & WithTranslationProps & PropsData
class Index extends Component<PropsType & DispatchProps> {

    state = {
        remark: null,
    }

    timeId;
    componentDidMount() {
        if (typeof window.orientation !== "undefined") {
            let scale = window.screen.availWidth / 1190;
            if (/android/i.test(navigator.userAgent)) {
                (document.body.style as any).zoom = scale;
            }
            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                (document.body.style as any).transformOrigin = "0 0";
                (document.body.style as any).transform = `scale(${scale})`
            }
        }

        let id = this.props.match.params.id;
        this.props.getReportDetail(id);
        this.timeId = setInterval(() => {
            let report = this.props.reportDetail || {};
            const header = report.header || {};
            if (header && (header.state === "SUCCESS" || header.state === "FAIL")) {
                clearInterval(this.timeId)
                this.timeId = null;
            }
            else {
                this.props.getReportDetailByStatus(id);
            }
        }, 4000)
    }

    componentWillUnmount() {
        if (this.timeId) {
            clearInterval(this.timeId);
        }
    }

    returnReportVaild = () => {

        let report = this.props.reportDetail || {};
        let reportVaild = true;
        let reportError = '';
        let reportProcessing = true;
        if (report && report.state === 'PROCESSING_STATE_COMPLETED') {
            reportProcessing = false
            if (report.error !== "REPORT_ERROR_NULL") {
                reportVaild = false;
                reportError += returnReportErrorText(report.error);
            }
        }

        return {
            reportVaild,
            reportError,
            reportProcessing
        }
    }

    handleChangeRemark = (e) => {
        this.setState({
            remark: e.target.value
        })
    }

    onSaveRemark = (remark) => {
        let id = this.props.match.params.id;
        let req = {
            remark: remark,
            ticket: id,
        }
        this.props.saveReportRemark(req);
    }

    returnConclusion = () => {
        let reportDetail = this.props.reportDetail || {};
        let trainingAdvice: string[] = [];
        let insoleAdvice: string[] = [];

        const i18n = this.props.i18n;

        if (!i18n) {
            return '';
        }

        const body = reportDetail.body || {};
        const report = body.footPressure || {};

        let inversion = false;
        let eversion = false;
        report.left.eversionInversionOfFootList.map((item) => {
            if (item.search("INVERSION") != -1) {
                inversion = true;
            }
            if (item.search("EVERSION") != -1) {
                eversion = true;
            }
        })

        report.right.eversionInversionOfFootList.map((item) => {
            if (item.search("INVERSION") != -1) {
                inversion = true;
            }
            if (item.search("EVERSION") != -1) {
                eversion = true;
            }
        })

        let arr: string[] = [];
        if (inversion) {
            trainingAdvice.push(i18n.t('inversionTrainAdvice'))
            insoleAdvice.push(i18n.t('tooHardSolesInsoleAdvice'))
            insoleAdvice.push(i18n.t('inversionInsoleAdvice'))
        }
        if (eversion) {
            trainingAdvice.push(i18n.t('eversionTrainAdvice'))
            if (!inversion) {
                insoleAdvice.push(i18n.t('tooHardSolesInsoleAdvice'))
            }
            insoleAdvice.push(i18n.t('eversionInsoleAdvice'))
        }
        if (inversion || eversion) {
            let end = i18n.language == "en" ? "." : "。";
            trainingAdvice.push(i18n.t('plantarFasciitisTrainAdvice'))
            insoleAdvice.push(i18n.t('plantarFasciitisInsoleAdvice'))
            arr.push(`${i18n.t("trainAdvice")}：${trainingAdvice.join("；")}${end}`);
            arr.push(`${i18n.t("insoleAdvice")}：${insoleAdvice.join("；")}${end}`);
        }
        else {
            arr.push(i18n.t('adviceNormal'));
        }
        return arr.join('\n');
    }


    render() {

        const report = this.props.reportDetail || {};

        const header = report.header || {};
        const examinee = header.examinee || {};
        const store = header.store || {};
        const state = header.state || "PROCESSING";
        const error = header.error || {};

        let createTime = '';
        if (header.createTime) {
            let date = new Date(new Date(header.createTime).getTime() + 8 * 3600 * 1000)
            let dateJson = date.toJSON()
            createTime = dateJson.substring(0, 19).replace('T', ' ');
        }

        const body = report.body || {};
        const scanReport = body.footShape || {};
        const staticReport = body.footPressure || {};

        const i18n = this.props.i18n;
        if (!i18n) {
            return null;
        }

        const language = i18n.language;
        const inExport = this.props.inExport;

        const pdfClass = inExport ? " print" : "";
        window.document.title = i18n.t("silizhuReportTitle");

        let params = new URLSearchParams(window.location.search);
        let isSave = params.get('editable') === 'true' ? true : false;
        let remarkState = this.state.remark;
        let remarkProp = report.remark;
        let remark = remarkProp || '';
        if (!remark && state === "SUCCESS") {
            remark = this.returnConclusion();
        }
        if (remarkState !== null) {
            remark = remarkState;
        }

        return (
            <div className={"contentComs " + language + pdfClass}>
                <div className='headTitle'>
                    <h3>{i18n.t("silizhuReportTitle")}</h3>
                    {
                        store.logo &&
                        <img
                            src={`${store.logo}?${new Date().getTime}`}
                            crossOrigin="anonymous"
                        />
                    }
                </div>
                <CustomerInfo
                    examinee={examinee}
                    createTime={createTime}
                    title={i18n.t("silizhuReportTitle")}
                    logo={report.orgLogo}
                />
                {
                    state === "PROCESSING" &&
                    (
                        <div className="reportProcessing">
                            <img src={icon_reportProcessing} />
                            <p>{i18n.t('reportProcessing')}<span className="animation_dot">...</span></p>
                        </div>
                    )
                }
                {
                    state === "FAIL" &&
                    (
                        <div className="reportError">
                            <img src={icon_reportError} />
                            <p>{i18n.t('reportInvalid')}</p>
                            <p className="error">{error.message}</p>
                        </div>
                    )
                }
                {
                    state === "SUCCESS" && 
                    (
                        <div className='contentComs-content'>
                            <TypeAndSize
                                data={scanReport}
                                inExport={inExport}
                            />
                            <LengthAndWidth
                                data={scanReport}
                                inExport={inExport}
                            />

                            {/* 静态参数分区 */}
                            {
                                <div>
                                    <FootPartition
                                        static={staticReport}
                                    />
                                </div>
                            }

                            <div className={`${inExport ? 'printStanding-page-content' : ''}`}>

                                 {/* 足弓分析 */}
                                 {
                                    <ArchAnaly
                                        data={
                                            {
                                                left: staticReport.left.arch,
                                                right: staticReport.right.arch,
                                            }
                                        }
                                        staticReport={staticReport}
                                    />
                                }

                                {/* 静态双脚 */}
                                {
                                    <FeetData
                                        static={staticReport}
                                    />
                                }
                               

                            </div>

                            <div>

                                {/* 双脚综合 */}
                                {
                                    <FeetSynthesis
                                        static={staticReport}
                                    />
                                }

                                {/* 稳定性分析 */}
                                {
                                    <StableAnaly data={staticReport} />
                                }

                                {/* 建议 */}
                                <div className="reportCom-advice">
                                    <p className='reportCom-container-title'>
                                        <span>{i18n.t('riskAndTrainAdvice')}</span>
                                    </p>
                                    {
                                        isSave && !inExport ?
                                            (
                                                <div className="conclusion-save">
                                                    <TextArea
                                                        autoSize={{
                                                            minRows: 6,
                                                            maxRows: 20
                                                        }}
                                                        value={remark}
                                                        onChange={this.handleChangeRemark}
                                                    />
                                                    <Button
                                                        className="btn-save"
                                                        type="primary"
                                                        onClick={() => this.onSaveRemark(remark)}
                                                    >{i18n.t('saveAdvice')}</Button>
                                                </div>
                                            ) :
                                            (
                                                <div className="conclusion">
                                                    <p>{remark}</p>
                                                </div>
                                            )
                                    }
                                </div>
                            </div>


                        </div>
                    )
                }

            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        reportDetail: state.silizhuReport.reportDetail,
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        getReportDetail: (data) => {
            dispatch(actionGetReportDetail(data))
        },
        saveReportRemark: (data) => {
            dispatch(actionSaveReportRemark(data))
        },
        getReportDetailByStatus: (data) => {
            dispatch(actionGetReportDetailByStatus(data))
        },
    }
}
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withRouter(Index)))